import { Grid, Autocomplete, TextField, AutocompletePropsSizeOverrides } from "@mui/material";
import { ATRecord, getField } from "@rogoag/airtable";
import { FieldSet } from "airtable";
import PortalTooltip, { MUITooltipPlacement } from "./PortalTooltip";

interface Props<T extends FieldSet> {
    onChange: (value: ATRecord<T> | null) => void | Promise<void>;
    loading?: boolean;
    options: ATRecord<T>[];
    selectedOption: ATRecord<T> | null;
    label: string;
    optionFormatter?: (option: ATRecord<T>) => string;
    tooltip?: React.ReactNode;
    size?: "small" | "medium" | undefined;
    style?: React.CSSProperties;
    placement?: MUITooltipPlacement;
}

export default function AirtableRecordSelectionAutocomplete<T extends FieldSet>(
    {
        onChange,
        loading,
        options,
        selectedOption,
        label,
        optionFormatter,
        tooltip,
        size,
        style,
        placement
    }: Props<T>) {
    return <Grid item xs={12}>
        <Autocomplete
            style={style}
            disabled={!!loading}
            options={options}
            value={selectedOption}
            getOptionKey={(option) => option.id}
            getOptionLabel={(option) => optionFormatter ? optionFormatter(option) : getField(option, "Name").toString()}
            size={size ?? "medium"}
            onChange={async (event, value) => {
                event.stopPropagation();
                await onChange(value)
            }}
            renderInput={(params) => {
                //console.log(`ATRecordSelection`, label);
                return tooltip ?
                    <PortalTooltip title={tooltip} placement={placement}>
                        <TextField {...params} label={label} variant="outlined" />
                    </PortalTooltip> :
                    <TextField {...params} label={label} variant="outlined" />
            }}
        />
    </Grid >
}